import {
  createContext,
  useContext,
  useLayoutEffect,
  type Dispatch,
  type SetStateAction,
} from 'react';

export const HoldContext = createContext<Dispatch<SetStateAction<number>>>(() => undefined);

/** Holds the surrounding login column in place while this content shows, so it opens downward. */
export const useHoldLoginColumn = (showing: boolean) => {
  const hold = useContext(HoldContext);
  useLayoutEffect(() => {
    if (!showing) return;
    hold((count) => count + 1);
    return () => hold((count) => count - 1);
  }, [showing, hold]);
};
